import { connect } from 'react-redux';

import NavigationExecutionArea from '../../components/navigation/NavigationExecutionArea';
import { getCSVExecuteDataFromJobIds } from '../../reducers/analyticsApp';

const mapStateToProps = (state) => {
  const executeCsvData = getCSVExecuteDataFromJobIds(state);

  return {
    count: executeCsvData.length,
  };
};

export default connect(mapStateToProps)(NavigationExecutionArea);
